import * as amplitudeBrowser from '@amplitude/analytics-browser';
import { getLDClientInstance } from 'context/LDContext';
import { getFromSessionStorage } from 'core/utils/sessionStorage';
export class AmplitudeEventCreator {
  private amplitudeGrowerId!: string | null;
  private amplitudeUserRole!: string | null;
  private amplitudeCountry!: string | null;
  private static _instance: AmplitudeEventCreator;

  private constructor() {}

  public static getInstance(): AmplitudeEventCreator {
    if (!AmplitudeEventCreator._instance) {
      AmplitudeEventCreator._instance = new AmplitudeEventCreator();
      amplitudeBrowser.init(process.env.REACT_APP_AMPLITUDE_API_KEY as string);
    }

    return AmplitudeEventCreator._instance;
  }

  private init() {
    this.amplitudeGrowerId = getFromSessionStorage('amplitude_grower_id');
    this.amplitudeUserRole = getFromSessionStorage('amplitude_user_role');
    this.amplitudeCountry = getFromSessionStorage('amplitude_country');
  }

  async createEvent(eventType: string, eventProperties?: any) {
    try {
      const ldClient = getLDClientInstance();
      if (!ldClient) {
        return;
      }
      await ldClient.waitForInitialization();
      const allFlags = ldClient.allFlags();
      if (!allFlags?.sendAmplitudeEvents) {
        return;
      }
      this.init();
      if (!eventProperties) {
        eventProperties = {};
      }
      const { userRole, country, userId, ...restEventProperties } = eventProperties;
      const identifyEvent = new amplitudeBrowser.Identify();
      identifyEvent.set('user role', userRole ?? this.amplitudeUserRole);
      amplitudeBrowser.identify(identifyEvent);
      amplitudeBrowser.setUserId(userId ?? this.amplitudeGrowerId);
      amplitudeBrowser.logEvent(eventType, {
        user_role: userRole ?? this.amplitudeUserRole,
        country: country ?? this.amplitudeCountry,
        ...restEventProperties,
      });
    } catch (err) {
      console.error('error creating amplitude event :: ', err);
    }
  }
}
